export function evaluationFailureText(t, error, { complete, partial, untouched, verified }) {
  const message = String(error?.message || '');
  const parts = [];
  if (message.includes('CHRONOLOGY_REPAIR_ONLY')) parts.push(t('help.evaluationResult.chronologyRepairOnly'));
  else if (message) parts.push(message);
  parts.push(verified ? t('help.evaluationResult.failedVerified', { complete, partial, untouched })
    : t('help.evaluationResult.failedUnknown'));
  if (partial > 0) parts.push(t('help.evaluationResult.partialWarning'));
  return parts.join(' ');
}
